import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=1f4a743a&scoped=true&"
import script from "./LeftNav.vue?vue&type=script&lang=js&"
export * from "./LeftNav.vue?vue&type=script&lang=js&"
import style0 from "./LeftNav.vue?vue&type=style&index=0&id=1f4a743a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a743a",
  null
  
)

export default component.exports